/**
 * Global Imports
*/

import React, { useEffect, useContext } from 'react';

/**
 * Root Imports
*/

import { PageContext } from '~/components/PageProvider';
import { IndexPermissionService } from '~/services/Permission';

/**
 * Local Imports
*/

import { PermissionContext } from '../../Providers/PermissionProvider';
import { ResourceManage } from '../../Widgets/ResourceManage';

/**
 * Exports
*/

/**
 * 
 */
export function IndexPermission(props) {
  /** Contexts **/
  
  const page = useContext(PageContext);
  
  /** Side-Effects **/

  useEffect(() => {
    handleMount();
  }, []);
  
  /** Event Handlers **/
  
  /**
   * 
   */
  const handleMount = () => {
    page.change({
      group: 'permissions',
      breadcrumbs: 'Permissions'
    });
  };
  
  /** Renderers **/

  /**
   * 
   */
  const renderIndex = () => (
    <div>Choose a permission.</div>
  );
  
  /** Output **/
  
  return (
    <ResourceManage
      group='permissions'
      context={ PermissionContext }
      service={ IndexPermissionService }
      renderIndex={ renderIndex }
    />
  );
}